<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field v-model="itemForm.riskItem" :label="labels.riskItem" disabled></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field v-model="itemForm.stdItemTxtRef" :label="labels.stdItemTxtRef" :disabled="true"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-textarea v-model="itemForm.stdItemTxtLn" :label="labels.stdItemTxtLn" :disabled="true" :rows="4"></v-textarea>
      </v-flex>
      <v-flex lg2 xs12>
        <v-text-field v-model="itemForm.uom" :label="labels.uom" :disabled="true"></v-text-field>
      </v-flex>
      <v-flex lg5 xs12>
        <v-text-field v-model="itemForm.uomShortDesc" :label="labels.uomShortDesc" :disabled="true"></v-text-field>
      </v-flex>
      <v-flex lg5 xs12>
        <v-text-field v-model="itemForm.uomVal" :label="labels.uomVal" :disabled="true"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-spacer class="mt-2"></v-spacer>
        <v-data-table :headers="headers" :items="itemList" class="elevation-1" :loading="loading">
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.subItemNo }}</td>
              <td>{{ row.item.subItemDesc }}</td>
              <td>{{ row.item.subItemLimit }}</td>
              <td class="table-action-header">
                <table-action :rowData="row" review @review="doSelectSubItem(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
              </td>
              <!-- <td style="text-align:center">
              <v-tooltip bottom>
                <v-btn icon v-on="on" color="primary" flat @click.prevent="doSelectSubItem(row.item)" :loading="policy.loading">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <span>{{labels.editSubItem}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn icon v-on="on" color="red" flat @click.prevent="doPromptRemove(row.item)" :loading="policy.loading">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <span>{{labels.delSubItem}}</span>
              </v-tooltip>
            </td> -->
            </tr>
          </template>
        </v-data-table>
        <confirm v-model="promptRemove" @ok="doRemove">{{ deleteSubItem }}</confirm>
      </v-flex>
      <v-flex xs12>
        <v-btn text color="primary" dark @click.prevent="doAddSubItem" :loading="policy.loading">
          <v-icon dark left>mdi-plus-box</v-icon>{{ labels.addSubItem }}
        </v-btn>
      </v-flex>
      <v-flex lg4 xs12>
        <v-text-field v-model="mainForm.subItemNo" :label="labels.subItemNo" disabled></v-text-field>
      </v-flex>
      <v-flex lg8 xs12> </v-flex>
      <v-flex xs12>
        <v-textarea
          v-model="mainForm.subItemDesc"
          :label="labels.subItemDesc"
          data-vv-name="subItemDesc"
          :data-vv-as="labels.subItemDesc"
          :error-messages="errors.collect('subItemDesc')"
          :rows="4"
          v-validate="'required'"
        ></v-textarea>
      </v-flex>
      <v-flex lg4 xs12>
        <v-text-field
          ref="subItemLimit"
          v-model="mainForm.subItemLimit"
          :label="labels.subItemLimit"
          :error-messages="errors.collect('subItemLimit')"
          data-vv-name="subItemLimit"
          :data-vv-as="labels.subItemLimit"
          v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
        ></v-text-field>
      </v-flex>
      <!-- <v-flex lg4 xs12>
        <v-autocomplete :items="yesnoList" v-model="mainForm.inclItemSi" :label="labels.inclItemSi" item-text="label" item-value="value" data-vv-name="inclItemSi" :data-vv-as="labels.inclItemSi" :error-messages="errors.collect('inclItemSi')"></v-autocomplete>
      </v-flex>
      <v-flex lg4 xs12>
        <v-autocomplete :items="yesnoList" v-model="mainForm.prtSch" :label="labels.prtSch" item-text="label" item-value="value" data-vv-name="prtSch" :data-vv-as="labels.prtSch" :error-messages="errors.collect('prtSch')"></v-autocomplete>
      </v-flex> -->
      <v-flex xs12>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click.prevent="doClose" :loading="policy.loading"
            ><span class="btn-normal-error">{{ labels.close }}</span></v-btn
          >
          <v-btn depressed type="submit" @click.prevent="doSave" :loading="policy.loading"
            ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
          >
          <warning v-model="warnSaveSubItem" @ok="doAcceptSaveSubItem">{{ warnSaveSubItemMsg }}</warning>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { POLICY_RISK_TAB } from '@/store/types'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import { removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      labels: {
        riskItem: 'Risk Item',
        stdItemTxtRef: 'Standard Item Text',
        stdItemTxtLn: 'Standard Item Text Description',
        uom: 'UOM',
        uomShortDesc: 'UOM Description',
        uomVal: 'Item Sum Insured',
        exit: 'Exit',
        close: 'Close',
        save: 'Save',
        tableTitle: 'Sub-item Summary',
        editSubItem: 'Edit Sub-item',
        delSubItem: 'Delete Sub-item',
        addSubItem: 'Add Sub-item',
        subItemNo: 'Sub-item No.',
        subItemDesc: 'Description',
        subItemLimit: 'Sub-limit'
        // inclItemSi: 'Print on Schedule',
        // prtSch: 'Include in Item SI'
      },
      itemForm: {
        riskItem: undefined,
        stdItemTxtRef: undefined,
        stdItemTxtLn: undefined,
        uom: undefined,
        uomShortDesc: undefined,
        uomVal: undefined
      },
      headers: [
        { text: 'Sub-item', align: 'left', value: 'subItemNo' },
        { text: 'Description', value: 'subItemDesc' },
        { text: 'Sub-limit', value: 'subItemLimit' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      itemList: [],
      loading: false,
      policy: {
        loading: false
      },
      selectedSubItem: undefined,
      promptRemove: undefined,
      deleteSubItem: undefined,
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        subItemNo: undefined,
        subItemDesc: undefined,
        subItemLimit: undefined,
        inclItemSi: undefined,
        prtSch: undefined,
        acceptSubItemLimit: false
      },
      resetForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        subItemNo: undefined,
        subItemDesc: undefined,
        subItemLimit: undefined,
        inclItemSi: undefined,
        prtSch: undefined,
        acceptSubItemLimit: false
      },
      yesnoList: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      warnSaveSubItem: false,
      warnSaveSubItemMsg: undefined,
      showErrorDialog: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    selectedRiskGrpNo() {
      return this.$store.state.underwriting.policy.selectedRiskGrpNo
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    },
    selectedItemNo() {
      return this.$store.state.underwriting.policy.selectedItemNo
    },
    polItem() {
      return this.$store.state.underwriting.policy.polItem
    },
    polItemUOM() {
      return this.$store.state.underwriting.policy.polItemUOM
    },
    getNewSubItem() {
      return this.itemList.filter(item => {
        return item.newSubItem === true
      })
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    doInit() {
      this.itemForm.riskItem =
        this.selectedRiskGrpNo.toString().padStart(2, '0') +
        '/' +
        this.selectedRiskNo.toString().padStart(3, '0') +
        '/' +
        this.selectedItemNo.toString().padStart(3, '0')
      this.itemForm.stdItemTxtRef = this.polItem.stdItemTxtRef
      this.itemForm.stdItemTxtLn = this.polItem.stdItemTxtLn
      this.itemForm.uom = this.polItemUOM.uom
      this.itemForm.uomShortDesc = this.polItemUOM.uomShortDesc
      this.itemForm.uomVal = this.polItemUOM.uomVal
      this.getPolSubItemList().then(() => {
        if (this.itemList.length > 0) {
          this.doSelectSubItem(this.itemList[0])
        } else {
          this.initMainForm()
        }
      })
    },
    initMainForm() {
      this.mainForm.polNo = undefined
      this.mainForm.renCnt = undefined
      this.mainForm.endtCnt = undefined
      this.mainForm.riskGrpNo = undefined
      this.mainForm.riskNo = undefined
      this.mainForm.itemNo = undefined
      this.mainForm.subItemNo = undefined
      this.mainForm.subItemDesc = undefined
      this.mainForm.subItemLimit = undefined
      this.mainForm.inclItemSi = undefined
      this.mainForm.prtSch = undefined

      // this.$refs.subItemLimit.$el.cleave.setRawValue(this.mainForm.subItemLimit)

      this.resetForm = clone(this.mainForm)
    },
    async getPolSubItemList() {
      const apiUrl = this.$store.state.underwriting.policySubItemSettings.menu.polSubItemList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.selectedRiskGrpNo,
            riskNo: this.selectedRiskNo,
            itemNo: this.selectedItemNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayList(result).then(() => {
            this.loading = false
          })
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayList(result) {
      const { data } = result
      if (data) {
        this.itemList = []
        data.data.map(item => {
          const convertItem = {
            polNo: item.polNo,
            renCnt: item.renCnt,
            endtCnt: item.endtCnt,
            riskGrpNo: item.riskGrpNo,
            riskNo: item.riskNo,
            itemNo: item.itemNo,
            subItemNo: item.subItemNo.toString().padStart(3, '0'),
            subItemDesc: item.subItemDesc,
            subItemLimit: formatPrice(item.subItemLimit),
            inclItemSi: item.inclItemSi,
            prtSch: item.prtSch,
            newSubItem: item.newSubItem
          }
          this.itemList.push(convertItem)
        })
      } else {
        this.itemList = []
      }
      return true
    },
    async doAddSubItem() {
      const apiUrl = this.$store.state.underwriting.policySubItemSettings.menu.addSubItem
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.selectedRiskGrpNo,
            riskNo: this.selectedRiskNo,
            itemNo: this.selectedItemNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayList(result).then(() => {
            this.policy.loading = false
            this.doSelectSubItem(this.getNewSubItem[0])
          })
          this.$toast.success('New Sub-Item Added')
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSelectSubItem(data) {
      this.setSubItem(data)
    },
    setSubItem(data) {
      this.mainForm.polNo = data.polNo
      this.mainForm.renCnt = data.renCnt
      this.mainForm.endtCnt = data.endtCnt
      this.mainForm.riskGrpNo = data.riskGrpNo
      this.mainForm.riskNo = data.riskNo
      this.mainForm.itemNo = data.itemNo
      this.mainForm.subItemNo = data.subItemNo
      this.mainForm.subItemDesc = data.subItemDesc
      this.mainForm.subItemLimit = data.subItemLimit
      this.mainForm.inclItemSi = data.inclItemSi
      this.mainForm.prtSch = data.prtSch
      this.mainForm.acceptSubItemLimit = false

      this.resetForm = clone(this.mainForm)
    },
    doPromptRemove(data) {
      this.selectedSubItem = data
      this.deleteSubItem = 'Confirm to Delete Sub-item No. ' + data.subItemNo + '?'
      this.promptRemove = true
    },
    async doRemove() {
      const apiUrl = this.$store.state.underwriting.policySubItemSettings.menu.delSubItem
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.selectedSubItem.polNo,
            renCnt: this.selectedSubItem.renCnt,
            endtCnt: this.selectedSubItem.endtCnt,
            riskGrpNo: this.selectedSubItem.riskGrpNo,
            riskNo: this.selectedSubItem.riskNo,
            itemNo: this.selectedSubItem.itemNo,
            subItemNo: this.selectedSubItem.subItemNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayList(result).then(() => {
            if (this.itemList.length > 0) {
              this.doSelectSubItem(this.itemList[0])
            } else {
              this.initMainForm()
            }
            this.policy.loading = false
          })
          this.$toast.success('Sub-item Successfully Deleted')
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doExit() {
      this.$store.commit(POLICY_RISK_TAB, 2)
      this.$router.push({ name: 'policyCoverage' })
    },
    doReset() {
      this.mainForm = clone(this.resetForm)
    },
    doClose() {
      this.$emit('close')
    },
    doSave() {
      if (this.mainForm.subItemNo !== undefined) {
        this.resetMessages()
        this.$validator.validateAll().then(result => {
          if (result) {
            this.policy.loading = true
            this.doPolSubItemSave().then(success => {
              if (success) {
                this.mainForm.subItemLimit = formatPrice(this.mainForm.subItemLimit)
                this.$emit('doSubItemSave')
                this.getPolSubItemList()
                this.$toast.success('Sub-item Successfully Saved')
                this.doClose()
              } else if (success === false) {
                this.$toast.error('Sub-item Save Failed')
              }
              this.policy.loading = false
            })
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    async doPolSubItemSave() {
      try {
        this.mainForm.subItemLimit = removeFormatNumber(this.mainForm.subItemLimit)
        const result = await this.$store.dispatch('savePolSubItem', this.mainForm)
        if (result) {
          return true
        } else {
          if (this.$store.state.underwriting.policy.polSubItem.saveError.types[0] === 'WARN') {
            this.warnSaveSubItemMsg = this.$store.state.underwriting.policy.polSubItem.saveError.messages[0]
            this.warnSaveSubItem = true
          } else if (this.$store.state.underwriting.policy.polSubItem.saveError.types[0] === 'ERROR') {
            this.messages.push({
              message: this.$store.state.underwriting.policy.polSubItem.saveError.messages[0]
            })
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    doAcceptSaveSubItem() {
      this.mainForm.acceptSubItemLimit = true
      this.doSave()
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySubItemSettings.init !== 1) {
      this.$store.dispatch('polSubItemInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style></style>
